import React from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import { CardList } from '@eventbrite/eds-card-list';
import SeriesEventCard from '../../../components/seriesEventCard/SeriesEventCard';
import { CARD_STYLE_SIMPLE } from '@eventbrite/eds-card';
import { trackSeriesTicketsClick } from '../../../actions/eventAnalytics';
import { navigateToTicketSelection } from '../../../actions/initialize';
import { getSeriesEvents } from '../../../actions/series';
import { getSeriesEventsFilteredAndSortedByStartDate } from '../../../selectors/series';
import PaginationLoader from '../../../components/PaginationLoader';
import { SERIES_PAGE_SIZE } from '../../../api/constants';
import { getShouldHideSeriesStartTimeFF } from '../../../selectors/app';

const SeriesEventCardList = ({
    currencyFormat,
    hasMoreItems,
    isRegEvent,
    onGetTicketsClick,
    onPageScroll,
    seriesEvents,
    shouldHideSeriesStartTime,
    locale,
    shouldShowTimezone,
}) => {
    if (isEmpty(seriesEvents)) {
        return null;
    }

    let paginationLoader = null;

    // If the list of seriesEvents to display is smaller than the series pagination size, we don't need to
    // show the spinner, e.g. the user filters the list before all of the events have been fetched from the API
    if (hasMoreItems && seriesEvents.length >= SERIES_PAGE_SIZE) {
        paginationLoader = <PaginationLoader onPageScroll={onPageScroll} />;
    }

    const items = map(seriesEvents, (event) => ({
        id: event.id,
        content: (
            <SeriesEventCard
                {...event}
                key={event.id}
                isRegEvent={isRegEvent}
                onClick={onGetTicketsClick}
                shouldShowTimezone={shouldShowTimezone}
                currencyFormat={currencyFormat}
                shouldHideSeriesStartTime={shouldHideSeriesStartTime}
                locale={locale}
            />
        ),
        style: CARD_STYLE_SIMPLE,
    }));

    return (
        <div data-spec="series-page-events-list">
            <CardList items={items} />
            {paginationLoader}
        </div>
    );
};

export const SeriesEventCardListContainer = connect(
    (state) => ({
        currencyFormat: state.app.currencyFormat,
        isRegEvent: state.app.isRegEvent,
        locale: state.app.locale,
        seriesEvents: getSeriesEventsFilteredAndSortedByStartDate(state),
        hasMoreItems: get(state, 'series.pagination.hasMoreItems', false),
        shouldShowTimezone: state.event.listingDisplayFlags.shouldShowTimezone,
        shouldHideSeriesStartTime: getShouldHideSeriesStartTimeFF(state),
    }),
    (dispatch) => ({
        onGetTicketsClick: (eventId) => {
            dispatch(trackSeriesTicketsClick(eventId));
            dispatch(navigateToTicketSelection(eventId));
        },
        onPageScroll: () => dispatch(getSeriesEvents({ showLoader: false })),
    }),
)(SeriesEventCardList);
